import React from 'react';
import { useController } from 'react-hook-form';
import classnames from 'classnames';
import styles from './Field.module.css';

function Field({ name, defaultValue, disabled, className, input: Input, ...rest }) {
  const {
    field: { value, onChange }
  } = useController({ name, defaultValue });

  return (
    <div
      className={classnames(styles.root, className, {
        [styles.disabled]: disabled
      })}
    >
      <Input {...rest} disabled={disabled} value={value} onChange={onChange} />
    </div>
  );
}

export default Field;
